[
  { "id": "09nf3p0qFXo", "type": "short", "title": "А ви питаєте, як загубитися в Карпатах #похід #карпати #україна", "publishedAt": "2026-04-08T14:21:40Z", "duration": "0:51", "views": 1113, "likes": 14, "comments": 0 },
  {
    "id": "0owmJe03aP8", "type": "video",
    "title": "Похід на один день зі Старої Гути на Ігровець. Карпати здивували, як завжди!",
    "description": "Одноденний маршрут Ґорґанами зі Старої Гути на вершину Ігровця — і океан хмар, що тягнеться аж до Івано-Франківська.",
    "publishedAt": "2026-04-08T14:00:02Z", "duration": "24:04", "views": 3572, "likes": 189, "comments": 29,
    "place": "Ігровець", "country": "Україна", "region": "ukraine", "lat": 48.69, "lng": 24.17,
    "playlists": ["mountains", "oneday"]
  },
  { "id": "ZSmEI3V5xbo", "type": "short", "title": "І це все за один похід! #карпати #mountains #похід #пригоди #буковель", "publishedAt": "2026-03-05T13:36:34Z", "duration": "0:45", "views": 1119, "likes": 32, "comments": 0 },
  { "id": "RyfdCurAxJM", "type": "short", "title": "Зате в Яремчі тепер є міні болдер-район #скелелазіння #боулдерінг #rockclimbing #bouldering", "publishedAt": "2026-02-23T12:22:30Z", "duration": "0:37", "views": 954, "likes": 21, "comments": 0 },
  {
    "id": "2Onr2RlQE2o", "type": "video",
    "title": "Ми повели друзів у їхній перший похід Карпатами… Буковель – Синяк – Хом’як – водоспад Гук",
    "publishedAt": "2026-02-20T15:30:04Z", "duration": "17:21", "views": 2468, "likes": 139, "comments": 20,
    "place": "Хом’як", "country": "Україна", "region": "ukraine", "lat": 48.37, "lng": 24.45,
    "playlists": ["mountains"]
  },
  { "id": "TJpWisglLm4", "type": "short", "title": "Перший раз на ратраку, перший раз ішла на Жандарм пішки в пошуках снігу. #драгобрат #карпати", "publishedAt": "2026-01-26T13:58:03Z", "duration": "0:35", "views": 1185, "likes": 21, "comments": 0 },
  { "id": "cS-hmVfu0gA", "type": "short", "title": "А ви який тип? #карпати #mountains #похід #hiking #nature", "publishedAt": "2025-12-28T09:01:21Z", "duration": "0:58", "views": 2840, "likes": 90, "comments": 11 },
  { "id": "WZoP9icdhrM", "type": "short", "title": "Якось Макс захотів пройти 60 км Карпатами, і я не стала його зупиняти. #карпати #похід #сивуля", "publishedAt": "2025-12-26T12:16:00Z", "duration": "0:52", "views": 6236, "likes": 136, "comments": 2 },
  {
    "id": "PnLK6rjgqhE", "type": "video",
    "title": "Похід 60 км Карпатами за день. Буковель – Бистриця – Салатручіль – Сивуля – Боревка – Стара Гута",
    "publishedAt": "2025-12-14T09:00:42Z", "duration": "27:52", "views": 1117, "likes": 64, "comments": 10,
    "place": "Сивуля", "country": "Україна", "region": "ukraine", "lat": 48.55, "lng": 24.12,
    "playlists": ["mountains", "oneday"]
  },
  { "id": "AnRIoV9mLIE", "type": "short", "title": "Як то кажуть, потяг рухається зі швидкістю найповільнішого вагона. #карпати", "publishedAt": "2025-11-11T15:10:22Z", "duration": "0:30", "views": 965, "likes": 27, "comments": 0 },
  { "id": "rtILiKnMEo8", "type": "short", "title": "Океан хмар, який тягнеться аж до Івано-Франківська. Перемичка між Ігровцем та Високою. #карпати", "publishedAt": "2025-11-11T12:23:00Z", "duration": "0:40", "views": 1263, "likes": 51, "comments": 0 },
  { "id": "6IHuLr19JjE", "type": "short", "title": "Вайб наших походів на вибування. Хто вижив — той молодець! #карпати #похід #грофа #mountains", "publishedAt": "2025-08-17T17:25:39Z", "duration": "0:36", "views": 983, "likes": 19, "comments": 1 },
  {
    "id": "MBkXcNupOCU", "type": "video",
    "title": "Похід в Карпати на два дні. Ґорґани: Осмолода – г. Кінь Ґрофецький, г. Ґрофа – г. Великий Канусяк",
    "publishedAt": "2025-08-12T13:46:18Z", "duration": "25:55", "views": 1937, "likes": 85, "comments": 23,
    "place": "Ґрофа", "country": "Україна", "region": "ukraine", "lat": 48.57, "lng": 24.03,
    "playlists": ["mountains"]
  },
  {
    "id": "b-InvgPoHlE", "type": "video",
    "title": "Карпати. Легкий похід м. Яремче – водоспад Дівочі сльози – гора Женець",
    "publishedAt": "2025-04-20T18:04:06Z", "duration": "21:16", "views": 1350, "likes": 65, "comments": 14,
    "place": "Гора Женець", "country": "Україна", "region": "ukraine", "lat": 48.43, "lng": 24.53,
    "playlists": ["mountains", "oneday"]
  },
  {
    "id": "bx_tXEE6RSs", "type": "video",
    "title": "Похід на один день. Карпати: Костел горган, Рокита Велика, Чемегівський каньйон",
    "publishedAt": "2025-03-01T13:02:11Z", "duration": "17:15", "views": 2699, "likes": 127, "comments": 18,
    "place": "Рокита Велика", "country": "Україна", "region": "ukraine", "lat": 48.5, "lng": 24.33,
    "playlists": ["mountains", "oneday"]
  },
  {
    "id": "Pa3ZZYzfJjE", "type": "video",
    "title": "Похід на один день. Австрія, Земмерінг",
    "publishedAt": "2024-12-11T08:00:17Z", "duration": "16:14", "views": 932, "likes": 56, "comments": 12,
    "place": "Земмерінг", "country": "Австрія", "region": "world", "lat": 47.63, "lng": 15.83,
    "playlists": ["oneday"]
  },
  {
    "id": "IS3zYklZ7s0", "type": "video",
    "title": "Big Boulder Battle 2023. Повні фінали змагань на скеледромі Funattic",
    "publishedAt": "2023-11-30T10:45:00Z", "duration": "1:25:07", "views": 363, "likes": 21, "comments": 3,
    "place": "Скеледром Funattic", "country": "Україна",
    "playlists": ["climbing"]
  },
  { "id": "kcGKpofOeVc", "type": "short", "title": "6с по ковбасам 😁", "publishedAt": "2023-10-17T10:59:24Z", "duration": "0:55", "views": 269, "likes": 11, "comments": 0 },
  { "id": "nOJizyWZOlA", "type": "short", "title": "І знову 6б. з пасивною паличкою, яку я затисла, аби не кидатися і зробити на статиці)", "publishedAt": "2023-10-13T08:37:22Z", "duration": "0:44", "views": 138, "likes": 11, "comments": 0 },
  { "id": "QE2ExXQaaPk", "type": "short", "title": "Весела 6а+ зі стрибком", "publishedAt": "2023-10-09T21:23:57Z", "duration": "0:31", "views": 228, "likes": 15, "comments": 0 },
  {
    "id": "xfXKb-clGUo", "type": "video",
    "title": "Карпати. Ворохта – Кукул – Кострича – Кривопільський перевал",
    "publishedAt": "2023-10-08T15:12:10Z", "duration": "26:57", "views": 13732, "likes": 573, "comments": 50,
    "place": "Кострича", "country": "Україна", "region": "ukraine", "lat": 48.21, "lng": 24.68,
    "playlists": ["mountains"]
  },
  { "id": "7wdkBxEP5mI", "type": "short", "title": "Пролаз 6б flash", "publishedAt": "2023-09-29T12:55:47Z", "duration": "0:43", "views": 282, "likes": 10, "comments": 0 },
  { "id": "_XJDet-4p-E", "type": "short", "title": "Пролаз 6б по манюньким зачіпкам", "publishedAt": "2023-09-26T21:55:29Z", "duration": "0:59", "views": 140, "likes": 9, "comments": 0 },
  {
    "id": "V_AhjT_X5dU", "type": "video",
    "title": "Карпати. Прогулянка на гору Маковиця. Із села Ямна в Яремче. Водоспад Пробій",
    "publishedAt": "2023-02-14T09:00:16Z", "duration": "12:20", "views": 2827, "likes": 116, "comments": 21,
    "place": "Маковиця", "country": "Україна", "region": "ukraine", "lat": 48.47, "lng": 24.59,
    "playlists": ["mountains", "oneday"]
  },
  {
    "id": "c9e5q-Ythws", "type": "video",
    "title": "Похід на один день. Зимові Карпати – Ґорґан Явірницький з Яремче",
    "publishedAt": "2023-01-23T09:00:21Z", "duration": "14:01", "views": 3802, "likes": 203, "comments": 24,
    "place": "Явірник-Ґорґан", "country": "Україна", "region": "ukraine", "lat": 48.48, "lng": 24.47,
    "playlists": ["mountains", "oneday"]
  },
  {
    "id": "Fg4XhJEN6dM", "type": "video",
    "title": "Похід в гори Карпати на один день. Буковель – Синяк – Хом’як – Татарів",
    "publishedAt": "2022-10-31T15:02:40Z", "duration": "11:44", "views": 3777, "likes": 151, "comments": 15,
    "place": "Синяк", "country": "Україна", "region": "ukraine", "lat": 48.41, "lng": 24.39,
    "playlists": ["mountains", "oneday"]
  },
  {
    "id": "CLS5Jg_IzDY", "type": "video",
    "title": "Похід в гори: Карпати, Ґорґани. Буковель, Бистриця, Велика Сивуля, Стара Гута, Чортка, Пасічна",
    "publishedAt": "2022-09-21T14:08:43Z", "duration": "35:24", "views": 6678, "likes": 226, "comments": 30,
    "place": "Велика Сивуля", "country": "Україна", "region": "ukraine", "lat": 48.56, "lng": 24.09,
    "playlists": ["mountains"]
  },
  {
    "id": "FKDmugHkBaQ", "type": "video",
    "title": "Леонідіо, Греція (Leonidio, Greece). Скелелазіння, гори, визначні місця",
    "publishedAt": "2022-02-17T09:00:07Z", "duration": "26:16", "views": 529, "likes": 41, "comments": 5,
    "place": "Леонідіо", "country": "Греція", "region": "world", "lat": 37.17, "lng": 22.86,
    "playlists": ["climbing"]
  },
  {
    "id": "biW4JTjk3C8", "type": "video",
    "title": "Дениші, Житомирська область. Лагідне скелелазіння недалеко від Києва",
    "publishedAt": "2021-11-03T14:11:12Z", "duration": "7:00", "views": 1447, "likes": 97, "comments": 10,
    "place": "Дениші", "country": "Україна", "region": "ukraine", "lat": 50.17, "lng": 28.62,
    "playlists": ["climbing"]
  },
  {
    "id": "E5eBnHijAVo", "type": "video",
    "title": "Невідома Австрія. Земмерінг, Грац, Мюрццушляґ. Скелелазіння в районі Адлітцграбен",
    "publishedAt": "2021-09-15T08:08:14Z", "duration": "33:31", "views": 944, "likes": 87, "comments": 19,
    "place": "Адлітцграбен", "country": "Австрія", "region": "world", "lat": 47.66, "lng": 15.9,
    "playlists": ["climbing"]
  },
  {
    "id": "U0mJP44bihA", "type": "video",
    "title": "Похід в гори на один день з Воловця в Пилипець. Карпати, Боржава. г. Плай, г. Великий Верх",
    "publishedAt": "2021-08-15T07:00:06Z", "duration": "11:50", "views": 7995, "likes": 281, "comments": 35,
    "place": "Великий Верх", "country": "Україна", "region": "ukraine", "lat": 48.81, "lng": 23.27,
    "playlists": ["mountains", "oneday"]
  },
  {
    "id": "9IFvYziBUBc", "type": "video",
    "title": "Туреччина, Датча (Datça). Як там скелелазіння. Як дістатися, де жити, що подивитися",
    "publishedAt": "2021-06-15T08:41:38Z", "duration": "23:21", "views": 837, "likes": 73, "comments": 6,
    "place": "Датча", "country": "Туреччина", "region": "world", "lat": 36.73, "lng": 27.69,
    "playlists": ["climbing"]
  },
  {
    "id": "xnwdvz4ukDA", "type": "video",
    "title": "Щербаті Цуглі. Катання на конях та еко-туризм в с. Прибірськ",
    "publishedAt": "2021-05-05T16:01:48Z", "duration": "9:03", "views": 852, "likes": 68, "comments": 5,
    "place": "Прибірськ", "country": "Україна", "region": "ukraine", "lat": 50.93, "lng": 29.98,
    "playlists": []
  },
  {
    "id": "nYbNrqyUxsM", "type": "video",
    "title": "Сонячний Драгобрат, 8 березня 2021. Катання на Оазі та з підйомника «Вершина Карпат»",
    "publishedAt": "2021-03-11T10:00:12Z", "duration": "6:07", "views": 358, "likes": 42, "comments": 8,
    "place": "Драгобрат", "country": "Україна", "region": "ukraine", "lat": 48.25, "lng": 24.24,
    "playlists": []
  },
  {
    "id": "yuSE85-Urh8", "type": "video",
    "title": "Похід вихідного дня. З с. Чорна Тиса через озеро Ворожеска, г. Велика Братківська, г. Чорна Клива",
    "publishedAt": "2020-10-16T08:43:07Z", "duration": "23:43", "views": 2934, "likes": 98, "comments": 22,
    "place": "Велика Братківська", "country": "Україна", "region": "ukraine", "lat": 48.29, "lng": 24.29,
    "playlists": ["mountains"]
  },
  {
    "id": "e104n4COKPA", "type": "video",
    "title": "Херсонська область 2020",
    "publishedAt": "2020-09-29T19:32:27Z", "duration": "6:54", "views": 761, "likes": 35, "comments": 6,
    "place": "Херсонщина", "country": "Україна", "region": "ukraine", "lat": 46.64, "lng": 32.61,
    "playlists": []
  },
  {
    "id": "Bk16eFAimxQ", "type": "video",
    "title": "Боулдерінг в Мигії 2020",
    "publishedAt": "2020-09-03T07:46:40Z", "duration": "19:50", "views": 343, "likes": 26, "comments": 2,
    "place": "Мигія", "country": "Україна", "region": "ukraine", "lat": 47.93, "lng": 31.03,
    "playlists": ["climbing"]
  },
  {
    "id": "7zColp4E1zY", "type": "video",
    "title": "Боулдерінг в Мигії. Тизер",
    "publishedAt": "2020-08-15T13:51:47Z", "duration": "1:22", "views": 121, "likes": 10, "comments": 1,
    "playlists": ["climbing"]
  },
  {
    "id": "5bE8L3jHyfU", "type": "video",
    "title": "Vlog 5. Берн, Нойшванштайн",
    "publishedAt": "2020-06-14T18:29:02Z", "duration": "11:33", "views": 156, "likes": 15, "comments": 3,
    "place": "Берн", "country": "Швейцарія", "region": "world", "lat": 46.95, "lng": 7.45,
    "playlists": ["eurotrip"]
  },
  {
    "id": "RhKqGnDDV2E", "type": "video",
    "title": "Vlog 4. Швейцарія",
    "publishedAt": "2020-05-31T19:55:56Z", "duration": "17:04", "views": 132, "likes": 10, "comments": 0,
    "place": "Швейцарія", "country": "Швейцарія", "region": "world", "lat": 46.8, "lng": 8.23,
    "playlists": ["eurotrip"]
  },
  {
    "id": "5e97sBHAssA", "type": "video",
    "title": "Vlog 3. Multi pitch in Imst, Austrian tunnels, Lichtenstein, Lucerne, Devil's bridge in Switzerland",
    "publishedAt": "2020-05-25T20:25:04Z", "duration": "17:22", "views": 111, "likes": 10, "comments": 0,
    "place": "Імст", "country": "Австрія", "region": "world", "lat": 47.24, "lng": 10.74,
    "playlists": ["eurotrip", "climbing"]
  },
  {
    "id": "NoHm7Hpgdmo", "type": "video",
    "title": "Vlog 2. Austria (St. Wolfgang, Salzburg, Innsbruck, Imst)",
    "publishedAt": "2020-05-17T15:15:04Z", "duration": "15:04", "views": 122, "likes": 10, "comments": 0,
    "place": "Зальцбург", "country": "Австрія", "region": "world", "lat": 47.8, "lng": 13.04,
    "playlists": ["eurotrip"]
  },
  {
    "id": "TcgJmOOOOss", "type": "video",
    "title": "Vlog 1. Moto GP і перші враження про Австрію",
    "publishedAt": "2020-05-12T10:50:54Z", "duration": "13:34", "views": 207, "likes": 13, "comments": 0,
    "place": "Шпільберг (Red Bull Ring)", "country": "Австрія", "region": "world", "lat": 47.22, "lng": 14.76,
    "playlists": ["eurotrip"]
  },
  {
    "id": "Yyu2N3aUnsA", "type": "video",
    "title": "Big Eurotrip. Teaser",
    "publishedAt": "2020-05-03T17:16:42Z", "duration": "1:00", "views": 267, "likes": 16, "comments": 1,
    "playlists": ["eurotrip"]
  }
]
